import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Button } from '@/components/ui/button';
import { CheckCircle2, Mail } from 'lucide-react';

const BoostSuccess = () => {
  return (
    <>
      <Helmet>
        <title>Boost activated — check your email · OdyVoy</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="min-h-screen bg-background flex items-center justify-center px-4">
        <div className="max-w-md w-full text-center rounded-3xl border border-border/60 bg-card p-8 shadow-xl">
          <div className="w-16 h-16 mx-auto rounded-full bg-primary/15 flex items-center justify-center mb-5">
            <CheckCircle2 className="w-8 h-8 text-primary" />
          </div>
          <h1 className="text-2xl font-bold text-foreground mb-2">You're in ✈️</h1>
          <p className="text-muted-foreground mb-6">
            Your 3-Day Boost Pass is active. We've emailed you a magic login link — no password needed.
          </p>
          <div className="rounded-xl bg-primary/5 border border-primary/20 p-4 text-left flex items-start gap-3 mb-6">
            <Mail className="w-5 h-5 text-primary shrink-0 mt-0.5" />
            <div className="text-sm text-foreground">
              <p className="font-semibold">Check your inbox</p>
              <p className="text-muted-foreground text-xs mt-0.5">
                Tap the link to open OdyVoy signed in. It expires in 1 hour — check spam if you don't see it.
              </p>
            </div>
          </div>
          <Button asChild variant="outline" className="w-full">
            <Link to="/auth">Sign in manually</Link>
          </Button>
        </div>
      </div>
    </>
  );
};

export default BoostSuccess;
